import { render, staticRenderFns } from "./IntentComponent.vue?vue&type=template&id=7f3f06ae"
import script from "./IntentComponent.vue?vue&type=script&lang=js"
export * from "./IntentComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports